import {
    Card,
    CardContent,
    CircularProgress,
    Grid,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography
} from "@mui/material"
import { format } from "date-fns"
import React from "react"
import { useSelector } from "react-redux"
import { useParams, useSearchParams } from "react-router-dom"
import SimpleTable from "../../components/Common/Elements"
import Loading from "../../components/Common/Loading"
import { useGetCmProgressQuery } from "../../core/api/cm-progress-api"
import { useGetStateV2CMQuery } from "../../core/api/cloclmaker-state-api"
import {
    countDisenchantedBuildings,
    formatDate,
    getDeviceIdAbsentWarning,
    getItemByName,
    getLastSession,
    HOUSES,
    paymentUserStatus,
    timestampToDate
} from "../../core/utils/constants"
import TechInfoCM from "../TechInfo/techInfoCM"
import UserSocialInfoCM from "../UserInfo/userSocialInfoCM"
import CmBanStatusCard from "../BanControl/CmBanStatusCard"
import SpammerControl from "../BanControl/SpammerControl"
import StateCopyLogCard from "../../components/Common/StateCopyLogCard"

function DashboardCM() {

    const version = window.localStorage.getItem('isProd') == 'true' ? 'v2' : 'v2';
    const {deviceId: deviceIdParam} = useParams();
    const [searchParams] = useSearchParams();
    const deviceId = deviceIdParam ?? "";
    const stateId = searchParams.get('vendorId') ?? "";
    const isProgress = searchParams.get('source') === 'progress';
    const deviceIdIsEmpty = isProgress ? !deviceId : (!deviceId && !stateId);

    const v2Query = useGetStateV2CMQuery({deviceId, stateId, version}, {skip: isProgress || deviceIdIsEmpty})
    const progressQuery = useGetCmProgressQuery(deviceId, {skip: !isProgress || deviceIdIsEmpty})
    const {
        data: obj,
        isLoading,
        isFetching,
        isError,
        error
    } = isProgress ? progressQuery : v2Query



    let panel1 = ""
    //
    // useEffect(() => {
    //     console.log(deviceIdIsEmpty)
    //     
    // }, [CommonData])
    //
    // useEffect(() => {
    //     
    // }, [])
    //
    // 

    const getFormattedDate = (obj, attr) => {
        if(!obj.hasOwnProperty(attr) || obj[attr] == undefined) {
            throw new Error("No session date");
        }
        if(!obj[attr].hasOwnProperty('_lastSessions')) {
            throw new Error("No session date");
        }
        let date = getLastSession(obj[attr]['_lastSessions'])
        return formatDate(date)
    }

    if (typeof obj === "object" && obj.hasOwnProperty('data')) {
        const data = obj.data
        if(data.hasOwnProperty('UserID')) {

            let source = {
                account_info: [],
                progress_info: []
            }


            let lastSession = 'N/A'
            try {
                lastSession = getFormattedDate(data, 'LastSessionsState')
            } catch (e) {
                try {
                    lastSession = getFormattedDate(data, 'SessionsState')
                } catch (e) {

                }
            }


            source = {
                account_info: [
                    ["Registration Date", format(data.RegDate*1000, "dd.MM.yyyy HH:mm:ss")],
                    ["Last session", lastSession],
                    ["Facebook ID", data?.["FacebookID"] ?? "N/A"],
                    ["User ID", data?.["UserID"] ?? "N/A"],
                    ["Global User ID", data['ServerSyncState']?.["globalUserID"] ?? "N/A"],
                    ["Username", data?.["ProfileState"]?.['_nickname'] ?? "N/A"],
                    ["Current version", data?.["CurrentClientVersion"] ?? "N/A"]
                ],
                progress_info: [
                    ["Next level", data.Match3Levels.NextLevelId],
                    //["Location", state.guidMap["Locations"][data.progress.locations.current]], //guid-Map
                    [
                        "Houses disenchanted",
                        `${countDisenchantedBuildings(data.Buildings.States)}/53`
                    ],
                    [
                        "Current house name",
                        HOUSES[Number.parseInt(data.Buildings.States[data.Buildings.States.length - 1].Id)]
                    ],
                    [
                        "Current house step",
                        data.Buildings.States[data.Buildings.States.length - 1].LevelNumber
                    ],
                    [
                        "Loop index",
                        data.Match3Levels.SagaLoopsFinished
                    ],
                    [
                        "Loop level",
                        data.Match3Levels.SagaLoopsLevelIndex
                    ]
                ],
                ingame_goods: [
                    [
                        "Ruby",
                        getItemByName(data.Items.States, "ruby").Count
                    ],
                    [
                        "Extra Lives",
                        data.LivesState._extraLives
                    ],
                    [
                        "Unlimited lives",
                        formatDate(timestampToDate(data.LivesState._infinityLivesTimeEnd))
                    ]
                ],
                payment_info: [
                    [
                        "Segment",
                        paymentUserStatus(data.PaymentsState.RealSpentSum)
                    ],
                    [
                        "Total",
                        Math.floor(data.PaymentsState.RealSpentSum)
                    ],
                    [
                        "Last payment date",
                        formatDate(timestampToDate(data.PaymentsState.RealSpentDate))
                    ]
                ],
                clan: [
                    ["Clan ID", data.ClansState !== undefined
                        ? data.ClansState.ClanId
                        : undefined],
                    ["Count reports", data.ClansState !== undefined
                        ? data.ClansState.ReportedChatMessages.length
                        : undefined]
                ],
                subscribe_info: [
                    [
                        "Current level",
                        data.hasOwnProperty('SubscriptionState') ? data.SubscriptionState.CurrentActiveLevel : ''
                    ]
                ]

            }

            let battlePass = data.OffersState._offers.filter(event => {
                return event["$type"] === "BPRStateData, Assembly-CSharp"
            });
            if(battlePass.length > 0) battlePass = battlePass[battlePass.length-1]
            else battlePass = false

            panel1 = <Grid container spacing={2}>
                <Grid size={4}>
                    <Card id={"account-info"}>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Account Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.account_info}/>
                        <Stack
                            direction="column"
                            sx={{
                                p: 2,
                                rowGap: 1
                            }}>
                            <SpammerControl userId={deviceId} project="clockmaker" />
                        </Stack>
                    </Card>
                </Grid>

                <Grid size={4}>
                    <Stack direction="column" spacing={2}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Ingame goods
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.ingame_goods}/>
                    </Card>
                    {battlePass && <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Battle Pass
                            </Typography>
                        </CardContent>
                        <Table>
                            <TableBody>
                                    <TableRow>
                                        <TableCell>GoldPassPurchased</TableCell>
                                        <TableCell>{battlePass.GoldPassPurchased == true ? 'YES' : 'NO'}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>PremiumPassPurchased</TableCell>
                                        <TableCell>{battlePass.PremiumPassPurchased == true ? 'YES' : 'NO'}</TableCell>
                                    </TableRow>
                            </TableBody>
                        </Table>
                    </Card>}
                    </Stack>
                </Grid>

                <Grid size={4}>
                    <Stack direction="column" spacing={2}>
                        {
                            isLoading || isFetching
                                ? <CircularProgress />
                                : <CmBanStatusCard userId={deviceId} userState={data} />
                        }
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Clan Info
                                </Typography>
                            </CardContent>
                            <SimpleTable data={source.clan}/>
                        </Card>
                    </Stack>
                </Grid>

                <Grid size={4}>
                    <Stack direction="column" spacing={2}>
                        <TechInfoCM isSimple={true} deviceId={deviceId}/>
                        <Card>
                            <CardContent>
                                <Typography sx={{fontSize: 16}}>
                                    Subscribe Info
                                </Typography>
                            </CardContent>
                            <SimpleTable data={source.subscribe_info}/>
                        </Card>
                    </Stack>
                </Grid>

                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Progress Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.progress_info}/>
                    </Card>
                </Grid>

                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Payment Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.payment_info}/>
                    </Card>
                </Grid>

                <Grid size={4}>
                    <UserSocialInfoCM deviceId={deviceId}/>
                </Grid>

                {!isProgress &&
                    <Grid size={12}>
                        <StateCopyLogCard logs={obj?.copyLogs}/>
                    </Grid>
                }
            </Grid>

        } else if (typeof obj === "object" && obj.data.hasOwnProperty('error')) {
            panel1 = obj.data.error
        }
    } else {
        panel1 = 'unknown error'
    }

    return (
        <>
            {deviceIdIsEmpty ? getDeviceIdAbsentWarning() :
                <Loading
                    isLoading={isLoading||isFetching}
                    isError={isError}
                    error={error}
                >
                    {panel1}
                </Loading>}

        </>
    );

}

export default DashboardCM
